export default __webpack_public_path__ + "static/media/icon-twitter.44905890.svg";